import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import FreeTrialIcon from "../IconComp/freeTrial";

interface SubscriptionConfirmModalProps {
  open: boolean;
  onClose: () => void;
}

const SubscriptionConfirmModal: React.FC<SubscriptionConfirmModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          "@media (min-width: 1200px) and (max-width: 1400px)": {
            left: "90%", // For screens between 1200px and 1400px
            transform: "translate(-85%, -50%)",
          },

          left: {
            xs: "50%", // for extra small screens
            lg: "98.5%", // for large screens
            xl: "95%",
          },
          transform: {
            xs: "translate(-50%, -50%)", // for extra small screens
            lg: "translate(-98%, -50%)", // for large screens
            xl: "translate(-95%, -50%)",
          },
          width: "80%",
          maxWidth: 480, // Sets a fixed width for larger screens
          height: "390px",
          bgcolor: "white",
          boxShadow: 44,
          //overflowY: "auto", // Enables vertical scrolling
          maxHeight: "100vh",
          px: { xs: 2, sm: 12 },
          py: 6,
        }}
      >
        <Box
          sx={{
            width: "295px",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Box>
            <FreeTrialIcon />
          </Box>

          <Box sx={{ fontSize: "24px", color: "#1E1D22", fontWeight: 500 }}>
            Your Subscription Request Has been Submitted
          </Box>
          <Box sx={{ fontSize: "12px", fontWeight: 400 }}>
            We will get back to you in a while
          </Box>
          {/* <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              fullWidth
              color="primary"
              onClick={onClose}
              sx={{
                bgcolor: "#0055A8",
                borderRadius: "5px",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 600,
                width: "153px",
              }}
            >
              close
            </Button>
          </Box> */}
        </Box>
      </Box>
    </Modal>
  );
};

export default SubscriptionConfirmModal;
